<script setup lang="ts">
import { ref, onMounted } from 'vue'; // 引入ref和onMounted
import { Logo, Style3dViewer, Watermark } from '@repo/components';
//import { useShareStore } from '@/store/share.ts';
//import { storeToRefs } from '@repo/stores';
import { RecentList, Toolbar, Toolbar1, Toolbar2 } from './components';
import { ToolbarContainer } from '@/components';
import { getLogoFromFabric } from '@/utils';
import { useRoute } from 'vue-router';
import { getAppConfig } from '@/utils';
import { useFabricStore } from '@/store/fabric.ts';

//const shareStore = useShareStore();
//const { logoUrl } = storeToRefs(shareStore);

const logo =  ref<string | undefined>('');
const route = useRoute();
const { id } = route.params as { [key: string]: string };

// 在onMounted或直接用await（setup支持顶层await）获取异步结果
onMounted(async () => {
  // 等待Promise完成，将结果赋值给响应式变量
  const logoname = await getLogoFromFabric(id||"default");
  if (logoname){
    const { OSS_BASE_URL, INDIVIDUAL_FABRIC_SHARES } = getAppConfig();
    logo.value = OSS_BASE_URL + INDIVIDUAL_FABRIC_SHARES + id + "/" + logoname;
  }
});

const fabricStore = useFabricStore();

</script>

<template>
  <div :class="$style.fabricPageContainer">
    <Watermark :text="fabricStore.fabricInfo?.enterpriseName" zIndex="1" rotate="300" />
    <Logo :class="$style.logo" :logo-url="logo" />
    <div :class="$style.style3d">
      <Style3dViewer />
    </div>
    <RecentList :class="$style.recentList" />
    <ToolbarContainer dark style="top: 10px; left: 10px; z-index: 3;" v-show="!logo">
      <Toolbar2 />
    </ToolbarContainer>
    <ToolbarContainer dark style="top: 10px;right: 10px; z-index: 3;">
      <Toolbar1 />
    </ToolbarContainer>
    <ToolbarContainer dark style="bottom: 75px;right: 10px; padding-bottom: 10px; z-index: 3;">
      <Toolbar />
    </ToolbarContainer>
  </div>

</template>

<style module>
.fabricPageContainer {
  background-color: #31363B;
  height: 100%;
  position: relative;
}

.logo {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

.style3d {
  background-color: #00000000; /*31363B*/
  height: calc(100% - 150px);
  position: relative;
  z-index: 2; /* 层级必须大于水印的 z-index（1） */
}

.recentList {
  background-color: #31363B;
  position: absolute;
  bottom: 0;
  padding: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
}
</style>
